import React, { createContext, useContext, useState, useEffect } from "react";
import { getBrochures } from "./contentful";

/*
  1️⃣ Create context
*/
const AppContext = createContext(null);

/*
  2️⃣ Provider component
*/
export const AppProvider = ({ children }) => {
  const [brochures, setBrochures] = useState([]);
  const [language, setLanguage] = useState("nl-NL");

  useEffect(() => {
    const lang = window.localStorage.getItem("lang") || "nl-NL";
    setLanguage(`${lang[0]?.toUpperCase()}${lang[1]}`);
  }, []);

  const fetchBrochures = () => {
    if (brochures.length) return;
    getBrochures().then((data) => setBrochures(data.map((item) => item.fields)));
  };
  const value = {
    brochures,
    fetchBrochures,
    language,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

/*
  3️⃣ Custom hook (recommended)
*/
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used inside AppProvider");
  }
  return context;
};
